import PurseSearch from '../../src/legacy/PurseSearch.tsx';
export default PurseSearch;
